<template>
  <nav class="pagination" role="navigation" aria-label="pagination" v-if="shouldPaginate">
    <a v-show="prevUrl"
       class="pagination-previous is-mobile is-hidden-tablet is-hidden-desktop is-size-7-tablet is-size-7-desktop has-text-weight-bold"
       @click.prevent="page--"><span :class="{'action-icons': actionIcons }" v-html="previous"></span></a>
    <a v-show="nextUrl"
       class="pagination-next is-mobile is-hidden-tablet is-hidden-desktop is-size-7-tablet is-size-7-desktop has-text-weight-bold"
       @click.prevent="page++"><span :class="{'action-icons': actionIcons }" v-html="next"></span></a>
    <ul class="pagination-list is-hidden-mobile">
      <li v-show="prevUrl"><a @click.prevent="page--"
                              class="pagination-previous is-size-7-touch is-size-7-desktop has-text-weight-bold is-hidden-mobile"
                              aria-label="Previous"><span :class="{'action-icons': actionIcons }" v-html="previous"></span></a></li>
      <li v-show="showFirstPageLink"><a @click.prevent="goToPage(1)"
                                        class="pagination-link is-size-7-touch is-size-7-desktop has-text-weight-bold"
                                        aria-label="Goto page 1">1</a></li>
      <li v-show="showFirstPageLink"><span
        class="pagination-ellipsis is-size-7-touch is-size-7-desktop has-text-weight-bold">&hellip;</span></li>
      <li v-for="n in pageNumbers"><a @click.prevent="goToPage(n)"
                                      :class="[{ 'is-current': n == page}, 'pagination-link', 'is-size-7-touch', 'is-size-7-desktop', 'has-text-weight-bold']"
                                      aria-label="`Goto page ${n}`">{{ n }}</a></li>
      <li v-show="showLastPageLink"><span
        class="pagination-ellipsis is-size-7-touch is-size-7-desktop has-text-weight-bold">&hellip;</span></li>
      <li v-show="showLastPageLink"><a @click.prevent="goToPage(lastPage)"
                                       class="pagination-link is-size-7-touch is-size-7-desktop has-text-weight-bold"
                                       :aria-label="`Goto page ${lastPage}`">{{ lastPage }}</a></li>
      <li v-show="nextUrl"><a @click.prevent="page++"
                              class="pagination-next is-size-7-touch is-size-7-desktop has-text-weight-bold is-hidden-mobile"
                              aria-label="Next"><span :class="{'action-icons': actionIcons }" v-html="next"></span></a></li>
    </ul>
  </nav>
</template>

<script>
/* eslint-disable indent,no-new,no-undef */

export default {
  name: 'paginator',
  props: ['dataSet', 'keyword_string'],
  data () {
    return {
      page: 1,
      prevUrl: false,
      nextUrl: false,
      lastPage: 1,
      url: undefined,
      keyword: undefined,
      previous: '&laquo;&nbsp;Previous',
      next: 'Next&nbsp;&raquo;',
      actionIcons: false
    }
  },
  watch: {
    keyword_string () {
      this.keyword = this.keyword_string
    },
    dataSet () {
      this.page = this.dataSet.current_page
      this.prevUrl = this.dataSet.prev_page_url
      this.nextUrl = this.dataSet.next_page_url
      this.lastPage = this.dataSet.last_page
    },
    page () {
      this.broadCast().updateUrl()
    }
  },
  computed: {
    shouldPaginate () {
      return !!this.prevUrl || !!this.nextUrl
    },
    pageNumbers () {
      const pageGap = Math.floor(this.dataSet.per_page / 2)
      const curPage = this.page
      return Array.from({length: this.dataSet.last_page}, (x, i) => i + 1)
        .filter((x) => x === curPage || (x >= curPage - pageGap && x <= curPage + pageGap))
    },
    showFirstPageLink () {
      return this.page + 1 > this.dataSet.per_page - 1
    },
    showLastPageLink () {
      return this.page - 1 <= (this.lastPage - this.dataSet.per_page + 1)
    }
  },
  methods: {
    broadCast () {
      return this.$emit('changed', this.page, this.keyword)
    },
    updateUrl () {
      if (this.keyword_string) {
        this.url = `?page=${this.page}&keyword=${this.keyword_string}`
      } else {
        this.url = '?page=' + this.page
      }
      history.pushState(null, null, this.url)
    },
    goToPage (page) {
      this.page = page
    }
  },
  created () {
    if (this.$route.name === 'Review List') {
      this.previous = '<'
      this.next = '>'
      this.actionIcons = true
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/_variables.scss";

.pagination-previous, .pagination-next, .pagination-link, .pagination-ellipsis {
  border: none;
  border-radius: 0;
  color: #58595b;
}

/*.pagination-previous:hover, .pagination-next:hover,*/
.pagination-link:hover, .pagination-link.is-current {
  border-radius: 100%;
  border: 2px solid map-get($colors, 'blue-dark');
  background-color: transparent;
}

.pagination-list {
  justify-content: center;
}

.action-icons {
  font-size: 19px;
}
</style>



// WEBPACK FOOTER //
// src/components/Paginator.vue